import React from 'react';
import { Progress, Tooltip } from 'antd';
import { profileFormatBytes } from '../../middleware';

type IShowDataProgress = {
    limit?: number;
    used?: number;
};
export const ShowDataProgress: React.FC<IShowDataProgress> = ({ limit, used }: IShowDataProgress) => {
    if (!limit && !used) {
        return null;
    } else {
        const percent = !used ? 0 : (used / (limit || 1)) * 100;

        return (
            <Tooltip
                title={`${percent.toFixed(2)}%  (${profileFormatBytes(used || 0)} / ${profileFormatBytes(limit || 0)})`}
            >
                <Progress percent={percent} showInfo={false} trailColor={'#1890ff'} strokeColor={'#ff4d4f'} />
            </Tooltip>
        );
    }
};
